import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Check from "@material-ui/icons/Check";
import SettingsOutlined from "@material-ui/icons/SettingsOutlined";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import { farShared } from "../../../../assets/jss/user/far/farTokens.jsx";

const useStyles = makeStyles(theme => {
    const s = farShared(theme);
    const t = s.t;
    return {
        card: {
            border: "1px solid "+(t.dark ? "rgba(110,168,255,0.55)" : t.info.border)+" !important",
            textAlign: "left"
        },
        head: { display: "flex", alignItems: "flex-start", gap: "12px" },
        icon: {
            flexShrink: 0, width: "48px", height: "48px", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center",
            backgroundColor: t.info.bg, color: t.dark ? t.link : t.accent, "& svg": { width: "28px", height: "28px" }
        },
        headText: { flex: 1, minWidth: 0 },
        bullets: {
            listStyle: "none", margin: "4px 0 0", padding: "12px 14px", borderRadius: "8px", backgroundColor: t.dark ? "rgba(255,255,255,0.03)" : t.surfaceAlt,
            display: "flex", flexDirection: "column", gap: "6px",
            "& li": { display: "flex", gap: "8px", alignItems: "flex-start", fontSize: "14px", lineHeight: "20px", color: t.text },
            "& svg": { width: "18px", height: "18px", color: t.success.solid, flexShrink: 0, marginTop: "1px" }
        },
        actions: { display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" },
        manage: { ...s.secondaryButton, "& svg": { width: "18px", height: "18px" } },
        learn: { ...s.focusRing, color: t.link+" !important", fontWeight: 600, fontSize: "14px", textDecoration: "underline", background: "none", border: "none", cursor: "pointer", padding: 0 },
        switchWrap: { marginLeft: "auto" },
        status: { fontSize: "13px", color: t.textMuted }
    };
});

function FarExtensionCard({ enabled, switchControl, onManage, onLearnMore, canManage }){
    const classes = useStyles();
    return (
        <div className={"extension "+classes.card}>
            <div className={classes.head}>
                <span className={classes.icon} aria-hidden="true"><VerifiedUser /></span>
                <div className={classes.headText}>
                    <p className="title">File Attachment Rules (FAR)</p>
                    <p className="description">Validate recipients based on file name, file location and defined rules when sending files through the portal.</p>
                </div>
            </div>
            <ul className={classes.bullets}>
                <li><Check aria-hidden="true" />Helps prevent sensitive or customer-specific documents from being sent to unintended recipients.</li>
                <li><Check aria-hidden="true" />Applies the same rules you use in the Outlook plug-in.</li>
                <li><Check aria-hidden="true" />Works with file name prefix and suffix rules on the web. Directory rules are checked by the Outlook plug-in.</li>
                <li><Check aria-hidden="true" />You'll be notified if any recipients are not authorized.</li>
            </ul>
            <div className={classes.actions}>
                <button type="button" className={classes.manage} onClick={onManage}><SettingsOutlined aria-hidden="true" />Manage Rules</button>
                <button type="button" className={classes.learn} onClick={onLearnMore}>Learn more</button>
                { !canManage ? <span className={classes.status}>{enabled ? "Enabled by your administrator" : "Disabled by your administrator"}</span> : null }
                <div className={classes.switchWrap}>{switchControl}</div>
            </div>
        </div>
    );
}

FarExtensionCard.defaultProps = { enabled: false, canManage: true };
FarExtensionCard.propTypes = {
    enabled: PropTypes.bool,
    switchControl: PropTypes.node.isRequired,
    onManage: PropTypes.func.isRequired,
    onLearnMore: PropTypes.func.isRequired,
    canManage: PropTypes.bool
};

export default FarExtensionCard;
